/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum FileOutputFormat {
    JSON = 'JSON',
    PLAIN = 'PLAIN'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const FileOutputFormatValidatorShape = [
    'JSON',
    'PLAIN'
];
export const FileOutputFormatValidator = yup.mixed().oneOf(FileOutputFormatValidatorShape);
export const FileOutputFormatStringifyShapeProperties = {};
export const FileOutputFormatStringifyShape: StringSchema = {
    title: 'FileOutputFormat Stringifier',
    type: 'string'
};
export const FileOutputFormatStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(FileOutputFormatStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function FileOutputFormatFromJSON(json: any): FileOutputFormat {
    return FileOutputFormatFromJSONTyped(json, false);
}
export function FileOutputFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileOutputFormat {
    return json as FileOutputFormat;
}
export function FileOutputFormatToJSON(value?: FileOutputFormat | null): any {
    return value as any;
}
